import React, { useEffect, useState } from 'react'
import HeaderTitle from './../../../components/HeaderTitle/index';
import { useNavigate, Navigate } from 'react-router-dom';
import BackButton from '../../../components/BackButton';
import axios from 'axios';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import moment from 'moment';
import { Controller, useForm } from 'react-hook-form';
import { Helmet } from 'react-helmet';
import Select from "react-select";
import { canCreateDemand, hasAnyRole, isAdmin } from '../../../utils/roleUtils';

/** Liste / react-select için: YİBF kodu ve kalan hak (limit − kullanılan) */
function formatYibfSelectLabel(item) {
  if (!item) return ''
  const limit = Number(item.numberOfPours) || 0
  const used = Number(item.used) || 0
  const left = Math.max(0, limit - used)
  const code = item.yibf != null ? String(item.yibf) : '—'
  return `${code} (kalan: ${left})`
}

function CreateRequest() {
  const navigate = useNavigate();
  const { token, role, companyId } = useSelector((state) => state.auth)
  const yapiDenetimAutoCompany = hasAnyRole(role, 'YAPI_DENETIM') && !isAdmin(role)

  const form = useForm()
  const saveRequest = (data) => {
    console.log("saveRequest", data);
    axios.post(`${process.env.REACT_APP_SERVICE_URL}/demands`, {
      licenceHolder: data.licenceHolder,
      yibfId: data.yibfId,
      cityId: data.cityId,
      townId: data.townId,
      address: data.address,
      elevation: data.elevation,
      cubicMeter: data.cubicMeter,
      concreteCastingDate: moment(data.concreteCastingDate).format('YYYY-MM-DD'),
      concreteCastingTime: data.concreteCastingTime,
      companyIds: [
        Number(data.concreteCompanyId), Number(data.buildingControlCompanyId)
      ],
      concreteTypeId: data.concreteTypeId
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        console.log(response.data)
        swal('Başarılı', 'Talep başarıyla oluşturuldu.', 'success')
          .then(() => {
            navigate('/requests')
          })
      })
      .catch((error) => {
        console.error(error)
        swal('Hata', error?.response?.data?.errorMessage, 'error')
      })
  }

  const [cities, setCities] = useState([])
  const [towns, setTowns] = useState([])
  const [concreteTypes, setConcreteTypes] = useState([])
  const [buildingControl, setBuildingControl] = useState([])
  const [concreteCompanies, setConcreteCompanies] = useState([])
  const [labTime, setLabTime] = useState([])
  const [yibfCodes, setYibfCodes] = useState([])

  const getCities = () => {
    axios.get(`${process.env.REACT_APP_SERVICE_URL}/address/city`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        //console.log("getCities",response.data)
        setCities(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const getTowns = (cityId) => {
    axios.get(`${process.env.REACT_APP_SERVICE_URL}/address/town?c=${cityId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        //console.log("getTowns",response.data)
        setTowns(response.data)
      })
      .catch((error) => {
        console.error(error)
      })

  }

  const getConcreteTypes = () => {
    axios.get(`${process.env.REACT_APP_SERVICE_URL}/concrete`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        //console.log("getConcreteTypes",response.data)
        setConcreteTypes(response.data)
      })
      .catch((error) => {
        console.error(error)
        setConcreteTypes([])
        swal('Hata', 'Beton sınıfları getirilirken bir hata oluştu.', 'error')
      })
  }

  const getCompanies = () => {
    axios.get(`${process.env.REACT_APP_SERVICE_URL}/company`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        //console.log("getCompanies",response.data)
        const buildingControl = response.data.filter((company) => company.companyTypeId === 1)
        const concreteCompanies = response.data.filter((company) => company.companyTypeId === 2)
        setBuildingControl(buildingControl)
        setConcreteCompanies(concreteCompanies)
      })
      .catch((error) => {
        console.error(error)
        swal('Hata', 'Firmalar getirilirken bir hata oluştu.', 'error')
      })
  }

  const getLabTime = (date) => {
    axios.get(`${process.env.REACT_APP_SERVICE_URL}/lab/times?localDate=${date}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        //console.log("getLabTime",response.data)
        setLabTime(response.data)
      })
      .catch((error) => {
        console.error(error)
        swal('Hata', 'Laboratuvar zamanları getirilirken bir hata oluştu.', 'error')

      })
  }

  const getYibfCodes = (companyId) => {
    axios.get(`${process.env.REACT_APP_SERVICE_URL}/yibf`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        //console.log("getYibfCodes",response.data)
        setYibfCodes(response.data)
      })
      .catch((error) => {
        console.error(error)
        swal('Hata', 'YBİF kodları getirilirken bir hata oluştu.', 'error')
        setYibfCodes([])
      })
  }

  useEffect(() => {
    getCities()
    getConcreteTypes()
    getCompanies()
    getYibfCodes()
  }, [])


  useEffect(() => {
    form.setValue("cityId", 54)
    getTowns(54)
  }, [cities])

  useEffect(() => {
    if (yapiDenetimAutoCompany && companyId != null) {
      form.setValue('buildingControlCompanyId', String(companyId))
    }
  }, [yapiDenetimAutoCompany, companyId, form])

  if (!canCreateDemand(role)) {
    return <Navigate to="/requests" replace />
  }

  return (
    <div className='container-fluid'>
      <Helmet>
        <title>Yeni Talep Oluştur</title>
        <meta name='description' content='Yeni talep oluştur' />
        <meta name='viewport' content='width=device-width, initial-scale=1, shrink-to-fit=no' />
      </Helmet>
      <HeaderTitle title='Yeni Talep Oluştur' description={'Yeni talep oluşturmak için aşağıdaki formu doldurunuz.'} />
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <BackButton />

              <form className='mt-3' onSubmit={form.handleSubmit(saveRequest)}>
                <div className='row'>
                  <div className='col-md'>
                    <div className='mb-3'>
                      <label htmlFor='title' className='form-label'>Ruhsat Sahibi</label>
                      <input type='text' className='form-control' name='licenceHolder' id='licenceHolder' {...form.register('licenceHolder', {
                        required: 'Bu alan zorunludur'
                      })} />
                      {
                        form.formState.errors.licenceHolder && <div className='text-danger mt-2'>{form.formState.errors.licenceHolder.message}</div>
                      }
                    </div>

                    <div className='mb-3'>
                      <div className='row'>
                        <div className='col-md'>
                          <label htmlFor='elevation' className='form-label'>Beton Döküm Tarihi</label>
                          <input type='date'
                            className='form-control' id='concreteCastingDate' name='concreteCastingDate' {...form.register('concreteCastingDate', {
                              required: 'Bu alan zorunludur'
                            })} onChange={(e) => getLabTime(e.target.value)}
                            min={
                              // min date is tomorrow
                              moment().add(1, 'days').format('YYYY-MM-DD')
                            } />
                          {
                            form.formState.errors.concreteCastingDate && <div className='text-danger mt-2'>{form.formState.errors.concreteCastingDate.message}</div>
                          }
                        </div>
                        <div className='col-md'>
                          <label htmlFor='elevation' className='form-label'>Beton Döküm Saati</label>
                          <select className='form-select' id='concreteCastingTime' name='concreteCastingTime' {...form.register('concreteCastingTime', {
                            validate: (value) => value != "0" || 'Saat seçiniz',
                            required: 'Bu alan zorunludur'
                          })}>
                            <option value="0">Saat Seçiniz</option>
                            {
                              labTime && labTime.map((time) => (
                                <option key={time.id}
                                  disabled={!time.available}
                                  value={time.time}>{time.time}</option>
                              ))
                            }
                          </select>
                          {
                            form.formState.errors.concreteCastingTime && <div className='text-danger mt-2'>{form.formState.errors.concreteCastingTime.message}</div>
                          }
                        </div>
                      </div>
                    </div>

                    {
                      !yapiDenetimAutoCompany && (
                        <div className='mb-3'>
                          <label htmlFor='yapiDenetim' className='form-label'>Yapı Denetim Firması</label>
                          <select className='form-select' id='yapiDenetim' name='buildingControlCompanyId' {...form.register('buildingControlCompanyId', {
                            validate: (value) => value != "0" || 'Firma seçiniz',
                            required: 'Bu alan zorunludur'
                          })}>
                            <option value="0">Firma Seçiniz</option>
                            {
                              buildingControl?.map((company) => (
                                <option key={company.id} value={company.id}>{company.name}</option>
                              ))
                            }
                          </select>
                        </div>
                      )
                    }

                    <div className='mb-3'>
                      <label htmlFor='betonFirmasi' className='form-label'>Beton Santrali</label>
                      <select className='form-select' id='betonFirmasi' name='concreteCompanyId' {...form.register('concreteCompanyId', {
                        validate: (value) => value != "0" || 'Firma seçiniz',
                        required: 'Bu alan zorunludur'
                      })}>
                        <option value='0'>Firma Seçiniz</option>
                        {
                          concreteCompanies?.map((company) => (
                            <option key={company.id} value={company.id}>{company.name}</option>
                          ))
                        }
                      </select>
                      {
                        form.formState.errors.concreteCompanyId && <div className='text-danger mt-2'>{form.formState.errors.concreteCompanyId.message}</div>
                      }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='concreteTypeId' className='form-label'>Beton Sınıfı</label>
                      <select className='form-select' id='concreteTypeId' name='concreteTypeId' {...form.register('concreteTypeId', {
                        validate: (value) => value != "0" || 'Sınıf seçiniz',
                        required: 'Bu alan zorunludur'
                      })}>
                        <option value='0'>Sınıf Seçiniz</option>
                        {
                          concreteTypes?.map((concreteType) => (
                            <option key={concreteType.id} value={concreteType.id}>{concreteType.name}</option>
                          ))
                        }
                      </select>
                      {
                        form.formState.errors.concreteTypeId && <div className='text-danger mt-2'>{form.formState.errors.concreteTypeId.message}</div>
                      }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='yibfCode' className='form-label'>YIBF Kodu</label>
                      <Controller
                        name='yibfId'
                        control={form.control}
                        rules={{
                          validate: (value) => value != "0" || 'Kod seçiniz',
                          required: 'Bu alan zorunludur'
                        }}
                        render={({ field }) => {
                          const selectedYibf = field.value
                            ? yibfCodes?.content?.find((yibfCode) => yibfCode.id == field.value)
                            : null
                          return (
                            <Select
                              {...field}
                              options={yibfCodes?.content?.map((yibfCode) => ({
                                value: yibfCode.id,
                                label: formatYibfSelectLabel(yibfCode)
                              }))}
                              placeholder='Kod Seçiniz'
                              onChange={(e) => field.onChange(e.value)}
                              value={selectedYibf
                                ? { value: field.value, label: formatYibfSelectLabel(selectedYibf) }
                                : null
                              }
                            />
                          )
                        }}

                      />
                      {
                        form.formState.errors.yibfId && <div className='text-danger mt-2'>{form.formState.errors.yibfId.message}</div>
                      }
                    </div>
                  </div>

                  <div className='col-md'>


                    <div className='mb-3'>
                      <label className='form-label'>İl</label>
                      <select className='form-select' {...form.register('cityId', {
                        validate: (value) => value != "0" || 'İl seçiniz',
                        required: 'Bu alan zorunludur'
                      })} onChange={(e) => getTowns(e.target.value)} id='cityId' name='cityId' defaultValue={54}>
                        <option value='0'>İl Seçiniz</option>
                        {cities?.map((city) => (
                          <option key={city.id} value={city.id}>{city.name}</option>
                        ))}
                      </select>
                      {
                        form.formState.errors.cityId && <div className='text-danger mt-2'>{form.formState.errors.cityId.message}</div>
                      }
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>İlçe</label>
                      <select className='form-select' id='townId' name='townId' {...form.register('townId', {
                        validate: (value) => value != "0" || 'İlçe seçiniz',
                        required: 'Bu alan zorunludur'
                      })}>
                        <option value='0'>İlçe Seçiniz</option>
                        {
                          towns?.map((town) => (
                            <option key={town.id} value={town.id}>{town.name}</option>
                          ))

                        }
                      </select>
                      {
                        form.formState.errors.townId && <div className='text-danger mt-2'>{form.formState.errors.townId.message}</div>
                      }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='address' className='form-label'>Adres</label>
                      <textarea className='form-control' id='address' rows='4'
                        name='address' {...form.register('address', {
                          required: 'Bu alan zorunludur'
                        })}
                      ></textarea>
                      {
                        form.formState.errors.address && <div className='text-danger mt-2'>{form.formState.errors.address.message}</div>
                      }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='elevation' className='form-label'>Blok / Kat / Yapı Elemanı</label>
                      <input type='text' className='form-control' id='elevation' name='elevation' {...form.register('elevation', {
                        required: 'Bu alan zorunludur'
                      })} />
                      {
                        form.formState.errors.elevation && <div className='text-danger mt-2'>{form.formState.errors.elevation.message}</div>
                      }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='cubicMeter' className='form-label'>Metreküp</label>
                      <input type='text' className='form-control' id='cubicMeter' name='cubicMeter' {...form.register('cubicMeter', {
                        required: 'Bu alan zorunludur'
                      })} />
                      {
                        form.formState.errors.cubicMeter && <div className='text-danger mt-2'>{form.formState.errors.cubicMeter.message}</div>
                      }
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md'>
                    <div className='mb-3'>
                      <div className='d-flex flex-wrap gap-2'>
                        <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Kaydet</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default CreateRequest